import React, { useState, useEffect } from "react";
import { TabButtonFlatButton, BaseButtons } from "../../../common-components";
import { colors } from "../../../../themes/Colors";
import { AgencyHeader, AgencyManagerPopUp } from "./components";
import SearchBar from "../../../common-components/search-bar/SearchBar";
import AgencyItem from "./components/agency-item/AgencyItem";

const AgencyDisplay = ({
  width,
  height,
  setToastPop,
  setMessage,
  setLoading,
  loading,
  setPopUpTitle,
  auth,
}) => {
  const [tableDisplay, setTableDisplay] = useState("approved");
  const [open, setOpen] = useState(false);

  const [approvedAgencyArray, setApprovedAgencyArray] = useState(null);
  const [pendingAgencyArray, setPendingAgencyArray] = useState(null);
  const [inactiveAgencyArray, setInactiveAgencyArray] = useState(null);
  const [defaultedAgencyArray, setDefaultedAgencyArray] = useState(null);

  const [originalDataArray, setOriginalDataArray] = useState(null); //retain original data for clearing search

  const [refresh, setRefresh] = useState(false);

  const [selectedAgency, setSelectedAgency] = useState(null);
  // const [approvedAgencyArray,setApprovedAgencyArray]=useState(null)

  const GetAgencyArrays = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/agency/getAllAdminAgencyData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.customerUserData.userId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        // setToastPop(true);
        // setMessage("Created Share Account");
        // setPopUpTitle("SUCCESS");
        setApprovedAgencyArray(respnseData.approved);
        setPendingAgencyArray(respnseData.pending);
        setDefaultedAgencyArray(respnseData.defaulted);
        setInactiveAgencyArray(respnseData.inactive);
        setOriginalDataArray(respnseData.approved);
        setLoading(false);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(respnseData.message);
        setLoading(false);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage(
        "No network try again after connecting, if ths persist please contact support"
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    setOpen(true);
  }, []);
  useEffect(() => {
    GetAgencyArrays();
  }, [refresh]);
  useEffect(() => {
    GetAgencyArrays();
  }, []);
  return (
    <div
      style={{
        height: open ? "100%" : 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "top",
        transition: "all 0.8s",
      }}
    >
      {/* catalog view */}
      {selectedAgency ? null : (
        <div
          style={{
            display: "flex",
            height: 40,
            backgroundColor: colors.greenDark,
            top: -40,
            position: "absolute",
          }}
        >
          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"APPROVED"}
              backgroundColor={
                tableDisplay === "approved"
                  ? colors.secondaryGrey
                  : colors.greenLight
              }
              textColor={
                tableDisplay === "approved" ? colors.greenDark : colors.white
              }
              onClick={() => setTableDisplay("approved")}
            />
          </div>
          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"REQUESTS"}
              backgroundColor={
                tableDisplay === "requests"
                  ? colors.secondaryGrey
                  : colors.greenLight
              }
              textColor={
                tableDisplay === "requests" ? colors.greenDark : colors.white
              }
              onClick={() => setTableDisplay("requests")}
            />
          </div>
          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"DEFAULTED | INACTIVE"}
              backgroundColor={
                tableDisplay === "inactive"
                  ? colors.secondaryGrey
                  : colors.greenLight
              }
              textColor={
                tableDisplay === "inactive" ? colors.greenDark : colors.white
              }
              onClick={() => setTableDisplay("inactive")}
            />
          </div>

          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"STATS"}
              backgroundColor={
                tableDisplay === "stats"
                  ? colors.secondaryGrey
                  : colors.greenLight
              }
              textColor={
                tableDisplay === "stats" ? colors.greenDark : colors.white
              }
              onClick={() => setTableDisplay("stats")}
            />
          </div>
        </div>
      )}
      <div
        style={{
          height: 55,
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ marginLeft: 20, fontSize: 18, fontWeight: "bold" }}>
          AGENCIES
        </div>
        <div style={{ flex: 0.5 }}></div>
        <SearchBar
          originalSearchArray={originalDataArray}
          arrayToSearchInput={approvedAgencyArray}
          setResultsArray={setApprovedAgencyArray}
        />
        <div style={{ flex: 0.5 }}></div>
      </div>
      <AgencyHeader />
      <div
        style={{
          flex: 1,
          width: "100%",
          //   flexWrap: "wrap",
          display: "flex",
          overflow: "scroll",
          justifyContent: "flex-start",
          alignItems: "center",
          flexDirection: "column",
          //   borderStyle: "solid",
        }}
      >
        {tableDisplay === "approved"
          ? approvedAgencyArray
            ? approvedAgencyArray.map((agency, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <AgencyItem
                      onViewClick={() => setSelectedAgency(agency)}
                      companyName={agency.companyName}
                      contactNumber={agency.companyContactNumber}
                      email={agency.companyEmail}
                      createdOn={agency.dateRequested.substring(0, 10)}
                      services={agency.companyServices.map((service, index) => {
                        return service.value === true ? (
                          <div style={{ marginRight: 5 }} key={index}>
                            {service.serviceType}
                          </div>
                        ) : null;
                      })}
                    />
                  </div>
                );
              })
            : "loading"
          : null}
        {tableDisplay === "requests"
          ? pendingAgencyArray
            ? pendingAgencyArray.map((agency, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <AgencyItem
                      onViewClick={() => setSelectedAgency(agency)}
                      companyName={agency.companyName}
                      contactNumber={agency.companyContactNumber}
                      email={agency.companyEmail}
                      createdOn={agency.dateRequested.substring(0, 10)}
                      services={agency.companyServices.map((service, index) => {
                        return service.value === true ? (
                          <div style={{ marginRight: 5 }} key={index}>
                            {service.serviceType}
                          </div>
                        ) : null;
                      })}
                    />
                  </div>
                );
              })
            : "loading"
          : null}
        {tableDisplay === "inactive"
          ? inactiveAgencyArray
            ? inactiveAgencyArray.map((agency, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <AgencyItem
                      onViewClick={() => setSelectedAgency(agency)}
                      companyName={agency.companyName}
                      contactNumber={agency.companyContactNumber}
                      email={agency.companyEmail}
                      createdOn={agency.dateRequested.substring(0, 10)}
                      services={agency.companyServices.map((service, index) => {
                        return service.value === true ? (
                          <div style={{ marginRight: 5 }} key={index}>
                            {service.serviceType}
                          </div>
                        ) : null;
                      })}
                    />
                  </div>
                );
              })
            : "loading"
          : null}
        {tableDisplay === "stats" ? <div>STATS</div> : null}
      </div>
      <AgencyManagerPopUp
        display={selectedAgency}
        setSelectedAgency={setSelectedAgency}
        selectedAgency={selectedAgency}
        auth={auth.customerUserData}
        setLoading={setLoading}
        setToastPop={setToastPop}
        setPopUpTitle={setPopUpTitle}
        setMessage={setMessage}
        loading={loading}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </div>
  );
};

export default AgencyDisplay;
